import _classCallCheck from "/codebuild/output/src1787262798/src/tpp-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src1787262798/src/tpp-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * DevExtreme (esm/data/data_source/operation_manager.js)
 * Version: 21.2.5
 * Build date: Mon Jan 17 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { CANCELED_TOKEN } from "./utils";

var OperationManager = /*#__PURE__*/function () {
  function OperationManager() {
    _classCallCheck(this, OperationManager);

    this._counter = -1;
    this._deferreds = {};
  }

  _createClass(OperationManager, [{
    key: "add",
    value: function add(deferred) {
      this._counter++;
      this._deferreds[this._counter] = deferred;
      return this._counter;
    }
  }, {
    key: "remove",
    value: function remove(operationId) {
      return delete this._deferreds[operationId];
    }
  }, {
    key: "cancel",
    value: function cancel(operationId) {
      if (operationId in this._deferreds) {
        this._deferreds[operationId].reject(CANCELED_TOKEN);

        return true;
      }

      return false;
    }
  }, {
    key: "cancelAll",
    value: function cancelAll() {
      while (this._counter > -1) {
        this.cancel(this._counter);
        this._counter--;
      }
    }
  }]);

  return OperationManager;
}();

export { OperationManager as default };